import { COURSE_DETAIL_PAGE_KEY } from '@/views/OrgCourseDetail/constants';

const es = {
  [COURSE_DETAIL_PAGE_KEY]: {
    UPDATED_AT: 'Actualizado el:',
    ABOUT_TITLE: '¿De qué trata este curso?',
    LESSONS_SECTION_TITLE: 'Temario del curso',
    WATCH_TRAILER: 'Mira el trailer',
    NEW: 'Nuevo',
    STUDENTS: 'Estudiantes',
    SEO_TITLE: 'Curso online de',
    SEO_TITLE_2: 'Curso online',
    SHOW_MORE: 'Ver más',
    SHOW_LESS: 'Ver menos',
    INFO_SECTION_TITLE: 'Información del curso:',
    TOTAL_DURATION: 'Duración:',
    TOTAL_ATTACHMENTS_TEXT: ' Archivos adjuntos',
    ATTACHMENT_TEXT: ' Archivo adjunto',
    ACCESS_TEXT: 'Accede por la aplicación',
    TEMPORAL_ACCESS: '¡Acceso gratis por 24hrs!',
    TRY_COURSE: '¡Pruébalo gratis!',
    FREE_SUBSCRIPTION: '¡INSCRÍBETE GRATIS!',
    SUBSCRIBE_NOW: '¡INSCRÍBETE AHORA!',
    GO_TO_COURSE: 'Ir al curso',
    REQUIRED: 'Obligatorio',

    LEVEL_LABEL: 'Nivel',
    LEVEL_TITLE: 'DIFICULTAD',
    MODULES: '{{count}} Módulo',
    MODULES_plural: '{{count}} Módulos',
    LESSONS_TOTAL: '{{count}} Clase',
    LESSONS_TOTAL_plural: '{{count}} Clases',
    TIME_DURATION: '{{totalDuration}} de duración total',

    ERROR_VIEW_MESSAGE: 'Ha ocurrido un error, por favor intenta nuevamente',
    ERROR_VIEW_BUTTON: 'Recargar página',
    ERROR_VIEW_COURSE_NOT_FOUND: 'Curso no disponible',
    ERROR_VIEW_COURSE_NOT_FOUND_DESCRIPTION:
      'Este curso puede no existir, pertenecer a otra organización o no tienes los permisos necesarios para acceder a él. Por favor, contacta a tu administrador si crees que esto es un error.',
    ERROR_VIEW_COURSE_NOT_FOUND_BUTTON: 'Ir a la página anterior',
    KNOWLEDGEHUB_HOME: 'Catálogo',
    KNOWLEDGEHUB_DETAIL: 'Detalle del curso',

    ENROLLMENTS_CURRENT_COURSE_DIALOG_TITLE:
      'Colaboradores inscritos en el curso',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_DESCRIPTION:
      'Consulta la lista de colaboradores inscritos en el curso. Podrás ver quiénes han sido agregados.',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_DESCRIPTION_BOLD:
      'Las nuevas asignaciones pueden tardar unos minutos en procesarse antes de visualizarse.',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_TABLE_TITLE: 'Usuarios',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_TABLE_SEARCH: 'Buscar',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_TABLE_HEAD_NAME: 'Nombre',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_TABLE_HEAD_ROLE: 'Asignado',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_TABLE_ROLE_ADMINISTRATOR: 'Administrador',
    ENROLLMENTS_CURRENT_COURSE_EMPTY:
      'Ningún colaborador a tu cargo tiene este curso asignado.',
    ENROLLMENTS_CURRENT_COURSE_INFO:
      'Consulta la lista de tus colaboradores inscritos en el curso. Podrás ver quién les asignó el contenido.',
    ENROLLMENTS_CURRENT_COURSE_INFO_AVATAR_LABEL: 'Colaboradores',
    ENROLLMENTS_CURRENT_COURSE_INFO_BUTTON: 'Ver más',
    ENROLLMENTS_CURRENT_COURSE_INFO_NOTE:
      'Las asignaciones pueden tardar al menos una hora o más en reflejarse los datos en la lista.',
    LEADER_ASSIGN_TEAM_BUTTON: 'Asignar a mi equipo',

    ENROLLMENTS_CURRENT_COURSE_ERROR_TITLE: 'Error al cargar datos',
    ENROLLMENTS_CURRENT_COURSE_ERROR_DESCRIPTION:
      'No pudimos cargar la información de inscripción. Inténtalo de nuevo.',
    ENROLLMENTS_CURRENT_COURSE_ERROR_BUTTON: 'Reintentar',
  },
};

export default es;
